import React, { FC, useRef } from 'react';
import { InView } from 'react-intersection-observer';
import { useIntl } from 'react-intl';
import { ProductProps } from '../types';
import { ProductSection } from '../ProductSection';
import ScrollCue from '../../scroll-cue/ScrollCue';
import {
  handleOnScrollCueClick,
} from '../../Homepage.events';
import { scrollToRef } from '../../helpers';
import {
  handleNewProductOnClick,
  handleNewProductsAllClick,
  observerCallbackOnNewProducts,
} from './NewProducts.event';
import { getConfiguration } from '../../../../helpers/Configuration';

interface NewProductsProps {
  newProducts?: ProductProps;
  scrollCuesInView: boolean;
  setScrollCuesInView: (inView: boolean) => void;
}

const { channel: { brand } } = getConfiguration();

export const NewProducts: FC<NewProductsProps> = ({
  newProducts,
  scrollCuesInView,
  setScrollCuesInView,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const intl = useIntl();

  const scrollTeaserTitle = intl.formatMessage(
    { id: 'general.scrollTeaser.title', defaultMessage: 'Continue scrolling' },
  );

  const isScrollCueInView = (inView: boolean) => {
    if (scrollCuesInView) return;
    setScrollCuesInView(inView);
  };

  if (!newProducts) return null;

  return (
    <div data-testid="new-product-list">
      {brand !== 'impressto' && (
        <InView onChange={isScrollCueInView}>
          <ScrollCue
            title={scrollTeaserTitle}
            onCueClick={() => {
              scrollToRef(ref);
              handleOnScrollCueClick('new_products');
            }}
          />
          <div className="scroll-anchor" ref={ref} />
        </InView>
      )}
      <ProductSection
        {...newProducts}
        onClick={handleNewProductOnClick}
        onLandingPageClick={handleNewProductsAllClick}
        onImpression={observerCallbackOnNewProducts}
      />
    </div>
  );
};
